import React, { useState, useEffect } from "react";


const data = [
  {
    id: 1,
    img: "https://media.istockphoto.com/id/1399565382/photo/young-happy-mixed-race-businessman-standing-with-his-arms-crossed-working-alone-in-an-office.jpg?s=612x612&w=0&k=20&c=buXwOYjA_tjt2O3-kcSKqkTp2lxKWJJ_Ttx2PhYe3VM=",
    name: "Mr.Pankaj Gaikwad",
    role: "Web Developer",
    text: "Great experience working with this IT company. The team is highly professional and delivers projects on time with excellent quality.",
  },
  {
    id: 2,
    img: "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
    name: "Miss.Priya Sangale",
    role: "Software Developer",
    text: "Best place to start your career in IT. The guidance and practical knowledge provided here is very useful.",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRc0-aQOMANuuFMLg2wwLQcH4fC8GbOKTAeEw&s",
    name: "Miss.Komal Agale",
    role: "Web Developer",
    text: "Best place to start your career in IT. The guidance and practical knowledge provided here is very useful.",
  },
  {
    id: 4,
    img: "https://img.freepik.com/free-photo/young-bearded-man-with-denim-shirt_273609-7230.jpg?semt=ais_hybrid&w=740&q=80",
    name: "Miss.Vaishanvi Satpute",
    role: "Intern Developer",
    text: "Very supportive team and great communication. Highly recommended for IT services and development work.",
  },
];

function Testimonial() {
  const [index, setIndex] = useState(0);

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % data.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="testimonial">
      <div className="container">

        <div className="section-header">
          <h2>Clients Review</h2>
          <h5 style={{'color':'white'}}>“What our clients say about our work and services.”</h5>
        </div>

        {/* NAV IMAGES */}
        <div className="testimonial-slider-nav">
          {data.map((item, i) => (
            <div
              key={item.id}
              className={`slider-nav ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            >
              <img src={item.img} alt="testimonial" />
            </div>
          ))}
        </div>

        {/* MAIN CONTENT */}
        <div className="testimonial-slider">
          <div className="slider-item">
            <h3>{data[index].name}</h3>
            <h4>{data[index].role}</h4>
            <p>{data[index].text}</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Testimonial;